import { Badge } from "../badge/Badge";
import { Tag } from "../tag/Tag";
import { AiFillStar } from 'react-icons/ai'

export function FeaturedTag({ label }) {
    return (
        <div className="flex flex-row items-center space-x-8 whitespace-nowrap max-w-max">
            <Tag label={label} white />
            <Badge label="Novidade" icon={<AiFillStar />} />
        </div>
    )
}
